import { render, staticRenderFns } from "./BeautyFaceCheckupDataSheet.vue?vue&type=template&id=3af43c8a&scoped=true"
import script from "./BeautyFaceCheckupDataSheet.vue?vue&type=script&lang=js"
export * from "./BeautyFaceCheckupDataSheet.vue?vue&type=script&lang=js"
import style0 from "./BeautyFaceCheckupDataSheet.vue?vue&type=style&index=0&id=3af43c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af43c8a",
  null
  
)

export default component.exports